<template>
    <div class="gcmcn-card related-user">
        <el-row :gutter="0">
            <el-col :span="15">
                <div class="name">{{ user.email }}</div>
            </el-col>
            <el-col :span="9">
                <div class="actions text-right">
                    <el-button
                        type="primary"
                        class="gcmcn-primary-btn taker-user-btn"
                        icon="el-icon-key"
                        @click="changeUserPassword"
                    ></el-button>
                    <el-popover
                        ref="popover"
                        placement="bottom"
                        width="150"
                        trigger="click"
                        popper-class="dark-popper"
                    >
                        <div>
                            <div class="popover-title">ARE YOU SURE ABOUT DELETING THIS USER ?</div>
                            <div class="actions">
                                <el-button
                                    type="text"
                                    class="decline"
                                    @click="hidePopover()"
                                >No</el-button>
                                <el-button
                                    type="text"
                                    class="accept"
                                    @click="deleteUser"
                                >Yes</el-button>
                            </div>
                        </div>
                        <el-button
                            slot="reference"
                            style="margin-left: 10px;"
                            type="danger"
                            class="gcmcn-danger-btn taker-user-btn"
                            icon="el-icon-delete"
                        ></el-button>
                    </el-popover>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>

export default {
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data (){
        return {
        };
    },
    computed: {
    },
    methods: {
        changeUserPassword() {
            this.$emit('editUserPassword', this.user);
        },
        deleteUser() {
            this.$emit('deleteUser', this.user);
        },

        hidePopover() {
            if (this.$refs['popover']) {
                this.$refs['popover'].showPopper = false;
            }
        },
    },
};
</script>

<style lang="scss">
.related-user {
    &.related-user {
        margin-top: 10px;
    }
    .taker-user-btn{
        font-size: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Setting/Users/user-card.vue